import { useContext } from "react";
import { CoachAuthContext } from "./CoachAuthContext";

export const useCoachAuthContext = () => {
    const context = useContext(CoachAuthContext);
    if(!context){
        throw Error('useCoachAuthContext must be used inside coach pages');
    }
    return context;
}